import React, { useState, useEffect } from "react";
import api from "../../Api/apiAxios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Loading from "../../Components/Loading";
import styles from "./GeracaoFaturamento.module.css";
import Mensagem from "../../Components/Mensagem";

const GeracaoFaturamento = () => {
    const navigate = useNavigate();
    const nivelUsuario = window.localStorage.getItem('nivelUsuario');  
    const idUsuario = window.localStorage.getItem('idUsuario');

    const [loading, setLoading] = useState(false);
    const [mensagem, setMensagem] = useState(null);
    const [enviarEmail, setEnviarEmail] = useState(false);
    const [mensagemErro, setMensagemErro] = useState('');
    const [periodo, setPeriodo] = useState("");

    useEffect(() => {
      const periodoAtual = getPeriodoAtualFormatado();
      setPeriodo(periodoAtual);
    }, []);

    const getPeriodoAtualFormatado = () => {
      const dataAtual = new Date();
      const dia = dataAtual.getDate();

      const mesReferencia = dia > 25 ? dataAtual.getMonth() + 1 : dataAtual.getMonth();
      const anoReferencia = dia > 25 && mesReferencia === 12 ? dataAtual.getFullYear() + 1 : dataAtual.getFullYear();

      const mesFormatado = String(mesReferencia + 1).padStart(2, "0");
      
      return `${anoReferencia}-${mesFormatado}-01`;
    }

    function handleChangePeriodo(e) {
      setPeriodo(`${e.target.value}-01`);
    }

    async function handleGerarFaturamento(ev) {
        ev.preventDefault();
        setLoading(true);

        try {
            const msgContrato = await handleGerarFaturamentoContrato();
            const msgPedidos = await handleGerarFaturamentoPedidos();
            const msgServicos = await handleGerarFaturamentoServicos();

            const mensagens = [msgContrato, msgPedidos, msgServicos].filter(Boolean);

            const periodoJaConsolidado = mensagens.every(msg =>
              msg.includes("já foi consolidado") ||
              msg.includes("Não é possível refazer o faturamento")
            );

            if (periodoJaConsolidado) {
              setMensagem(`O faturamento do período já está consolidado. Não é possível refazer o faturamento.`);
              return;
            }

            setMensagem(`Faturamento gerado com sucesso!\n${mensagens.join("\n")}`);
        } catch (error) {
            console.log("Erro ao gerar faturamento: ", error);
            setMensagemErro(error.message || "Erro desconhecido.");
        } finally {
            setLoading(false);
        }
    }

    async function handleConsolidarFaturamento() {
      try {
        const response = await api.post('/Faturamento/consolidar', null, {
          params: {
            periodo: periodo,
            usuarioConsolidacaoId: idUsuario
          }
        });

        if (response.data?.sucesso) {
          setMensagem(response.data.mensagem || "Faturamento consolidado com sucesso!");
        }
      } catch (error) {
        console.log("Erro ao consolidar faturamento: ", error);
        setMensagemErro(error?.response?.data?.mensagem || error.message || "Erro desconhecido.");
      }
      
    }

    async function handleGerarFaturamentoContrato() {
        const email = enviarEmail ? 1 : 0;
        try {
            const response = await api.get(`/Faturamento/${email}/${periodo}`);
            return response.data;
        } catch (error) {
            console.log("Erro ao gerar faturamento contratos: ", error);
            return "Erro ao gerar faturamento de contratos.";
        }
    }

    async function handleGerarFaturamentoPedidos() { 
        try {
            const response = await api.get(`/Faturamento/pedidos/${periodo}`);
            return response.data;
        } catch (error) {
            console.log("Erro ao gerar faturamento pedidos: ", error);
            return "Erro ao gerar faturamento de pedidos.";
        }
    }

    async function handleGerarFaturamentoServicos() { 
        try {
            const response = await api.get(`/Faturamento/servicos/${periodo}`);
            return response.data;
        } catch (error) {
            console.log("Erro ao gerar faturamento serviços: ", error);
            return "Erro ao gerar faturamento de serviços.";
        }
    }

    if (loading) return <Loading />;

    return (
        <section className={styles.form}>
            {mensagemErro && <Mensagem mensagem={mensagemErro} setMensagem={setMensagemErro} variant="danger" />}
            <Alert style={{ background: "ghostwhite", color: "black" }}>
                <Alert.Heading style={{ textAlign: "center" }}>Geração Faturamento Mensal</Alert.Heading>        

                <Row>
                    <Col md="3" />
                    <Col md="6">
                        <span style={{ fontSize: "small", color: "dimGray", marginLeft: "5rem" }}>
                            * Gera o faturamento de contratos e pedidos liberados dentro do período selecionado.
                        </span>
                    </Col>
                </Row>

                <br />

                <Row>
                    <Col md="3" />
                    <Col md="6">
                        <Form.Group controlId="periodo">
                            <Form.Label>Selecione o Mês</Form.Label>
                            <Form.Control 
                                type="month"
                                value={periodo.slice(0, 7)}
                                onChange={handleChangePeriodo}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <br />

                <Row>
                    <Col md="3" />
                    <Col md="6">
                        <Form.Check 
                            type="switch"
                            id="enviarEmail"
                            label="Enviar E-mail para as Revendas quando o faturamento estiver finalizado"                      
                            onChange={() => setEnviarEmail(!enviarEmail)}
                            checked={enviarEmail}
                        />
                    </Col>
                </Row>

                <br />
            </Alert>

            <div className={styles.areaBtn}>    
                <Button 
                  onClick={handleGerarFaturamento} 
                  variant="outline-primary" 
                  className={styles.btn} 
                  disabled={nivelUsuario !== "1"}
                >
                  Gerar Faturamento
                </Button>

                <Button 
                  onClick={handleConsolidarFaturamento} 
                  variant="outline-success" 
                  className={styles.btn} 
                  disabled={nivelUsuario !== "1"}
                >
                  Consolidar Faturamento
                </Button>

                <Button onClick={() => navigate(-1)} variant="outline-info" className={styles.btn}>
                  Sair
                </Button>
            </div>    

            {mensagem && <Mensagem mensagem={mensagem} setMensagem={setMensagem} variant="warning" />}                                 
        </section>   
    );
};

export default GeracaoFaturamento;
